import {
  ApiMasterLabelUPCData,
  ApiMasterLabelCrop,
  MasterUPCData,
  MasterCropData,
  MasterVariantData,
} from '../types';

function transformCrop(api: ApiMasterLabelCrop): MasterCropData {
  return {
    id: api.cropId,
    imageUrl: api.vizUrl,
    isInactive: !api.isActive,
    isPending: api.isPending,
    isMismatch: api.pendingReason === 'unknown_upc',
    storeId: String(api.storeId),
    itemNumber: api.itemNumber || undefined,
    source: api.source || undefined,
    barcode: api.barcode || undefined,
    normalizedUpc: api.normalizedUpc || undefined,
    createdAt: api.createdAt || undefined,
    orientation: api.orientation || undefined,
    classificationType: api.classificationType || undefined,
    imageResolution: api.imageResolution || undefined,
    createdBy: api.createdBy || undefined,
    updatedAt: api.updatedAt || undefined,
    updatedBy: api.updatedBy || undefined,
  };
}

export function transformApiUPCData(api: ApiMasterLabelUPCData): MasterUPCData {
  const itemNumber = api.itemNumber || api.upc;
  const variants = api.variants
    .map(v => ({
      id: v._id,
      persistedVariantId: v._id,
      itemNumber: v.itemNumber || itemNumber,
      representativeCropId: v.representativeCropId || v.crops[0]?.cropId || null,
      barcodeStatus: v.barcodeStatus,
      frontImageUrl: v.frontImageUrl || undefined,
      backImageUrl: v.backImageUrl || undefined,
      barcodeImageUrl: v.barcodeImageUrl || undefined,
      verifiedBarcode: v.verifiedBarcode || undefined,
      barcode: v.crops[0]?.barcode || undefined,
      crops: v.crops.map(transformCrop),
    } as MasterVariantData))
    .filter((variant) => variant.crops.length > 0 || Boolean(variant.verifiedBarcode));

  return {
    upc: api.upc,
    normalizedUpc: api.normalizedUpc,
    productName: api.productName || '',
    productImageUrl: api.productImageUrl || undefined,
    alternativeImageUrls: api.alternativeImageUrls && api.alternativeImageUrls.length > 0
      ? api.alternativeImageUrls
      : api.productImageUrl
        ? [api.productImageUrl]
        : undefined,
    itemNumber,
    barcodeSummary: api.barcodeSummary ? {
      primaryUpcs: api.barcodeSummary.primaryUpcs.map((entry) => ({
        upc: entry.upc,
        provenance: entry.provenance,
        storeDetails: entry.storeDetails.map((detail) => ({
          storeLabel: detail.storeLabel,
          role: detail.role,
          name: detail.name || undefined,
          casePack: detail.casePack || undefined,
          images: detail.images.map((image) => ({
            url: image.url,
            sourceLabel: image.sourceLabel || undefined,
          })),
        })),
      })),
      alternateUpcs: api.barcodeSummary.alternateUpcs.map((entry) => ({
        upc: entry.upc,
        provenance: entry.provenance,
        storeDetails: entry.storeDetails.map((detail) => ({
          storeLabel: detail.storeLabel,
          role: detail.role,
          name: detail.name || undefined,
          casePack: detail.casePack || undefined,
          images: detail.images.map((image) => ({
            url: image.url,
            sourceLabel: image.sourceLabel || undefined,
          })),
        })),
      })),
      casePacks: api.barcodeSummary.casePacks.map((entry) => ({
        upc: entry.upc,
        provenance: entry.provenance,
        storeDetails: entry.storeDetails.map((detail) => ({
          storeLabel: detail.storeLabel,
          role: detail.role,
          name: detail.name || undefined,
          casePack: detail.casePack || undefined,
          images: detail.images.map((image) => ({
            url: image.url,
            sourceLabel: image.sourceLabel || undefined,
          })),
        })),
      })),
    } : undefined,
    snapshotVersion: api.snapshotVersion,
    variants,
    pendingCrops: api.pendingCrops.map(transformCrop),
    unassignedCrops: api.unassignedCrops.map(transformCrop),
    nonFrontCrops: api.nonFrontCrops.map(transformCrop),
    cartonCrops: api.cartonCrops.map(transformCrop),
    inactiveCrops: api.inactiveCrops.map(transformCrop),
    differentItemCropIds: [],
  };
}
